import React from "react";
import { Link } from "react-router-dom";
import PublicAuthFrame from "../forgot/PublicAuthFrame";

function ResetExpired() {
  return (
    <PublicAuthFrame title="Link expired">
      <p className="text-center text-muted">
        Your password reset link has expired or is no longer valid.
      </p>
      <div className="text-center">
        <Link
          to="/signin"
          className="btn text-white"
          style={{ backgroundColor: "#29457c" }}
        >
          Back to sign in
        </Link>
      </div>
    </PublicAuthFrame>
  );
}

export default ResetExpired;
